
import PaginateButton from "../../../../../shared/PaginateButton/PaginateButton";
import { setSelfPacedCurrentPage } from "../../../../../store/features/AdminPanel/SelfPacedUser/SelfPacedUserSlice";
import { RootStore, useAppDispatch, useAppSelector } from "../../../../../store/store";
import "./index.scss";

const SelfPacedUserFooter = () => {
  const dispatch = useAppDispatch();
  const userState: any = useAppSelector((store: RootStore) => {
    return store.SelfPacedUserSlice;
  });
  const handlePagination = (num: number) => {
    dispatch(setSelfPacedCurrentPage(num+1));
  };
  return (
    <div className="mentor__pagination__section">
      <PaginateButton
        paginate={handlePagination}
        totalRows={userState.pagination_data?.total}
      />
    </div>
  );
};

export default SelfPacedUserFooter;
